module.exports = __webpack_public_path__ + "static/media/balcony.3b7244f2.svg";